<ui-bottom-sheet-shell
    [title]="'customers.ui.dettaglioNota' | transloco"
    (close)="onClose()"
>
    <div bottom-sheet-content class="note-bottom-sheet-card">
        <span class="body-small">{{ note.data | date:'dd/MM/yyyy HH:mm' }}</span>
        <span class="body-medium-emphasized">{{ note.titolo }}</span>
        <span class="body-small">{{ note.testo }}</span>
    </div>

    <div bottom-sheet-footer>
        @if (note.canEditNote) {
            <button matButton="filled" type="button" (click)="onEdit()">{{ 'customers.ui.modifica' | transloco }}</button>
        }
        <button matButton type="button" (click)="onClose()">{{ 'customers.ui.annulla' | transloco }}</button>
    </div>
</ui-bottom-sheet-shell>
